import React from 'react';
import { getModKeyLabel } from '../../utils/keyboard';

/** The key hints under the list (mockups §2.9), for the state the palette is in. */
export default function PaletteFooter({ t, sub, chip, activeItem }) {
  const mod = getModKeyLabel();
  const hints = sub
    ? [['←', t('palette.hint.back')], ['↵', t('palette.hint.run')], ['esc', t('palette.hint.back')]]
    : [
        ['↑↓', t('palette.hint.navigate')],
        ['↵', t('palette.hint.open')],
        [`${mod} ↵`, t('palette.hint.newTab')],
        activeItem?.result?.payload?.scopeProviderId ? ['Tab', t('palette.hint.scope')] : ['→', t('palette.hint.actions')],
        chip ? ['⌫', t('palette.hint.removeFilter')] : ['?', t('palette.hint.prefixes')],
        ['esc', t('palette.hint.close')],
      ];
  return (
    <div className="palette-footer" aria-hidden="true">
      {hints.map(([k, label]) => (
        <span key={`${k}-${label}`} className="palette-footer-hint">
          <kbd className="palette-kbd">{k}</kbd>
          {label}
        </span>
      ))}
    </div>
  );
}
